import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Honkify.js`}</h1>
    <p>{`Need a little more chaos in your life? Inspired by `}<a parentName="p" {...{
        "href": "https://goose.game"
      }}><em parentName="a">{`Untitled Goose Game`}</em></a>{`, you can now set a goose loose on your site to act like a jerk.`}</p>
    <p>{`When activated, all links on the site will stop working, instead triggering a “honk!” sound effect.`}</p>
    <p>{`Honk. Honk honk honk.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/jlengstorf/honkify"
        }}>{`See the source code`}</a></li>
    </ul>
    <h2>{`Praise for Honkify.js`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Nobody asked for this. – `}<a parentName="p" {...{
          "href": "https://twitter.com/poofichu/status/1179146980569878528"
        }}>{`Jessica Tremblay`}</a></p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`This is the worst thing you have ever done. – `}<a parentName="p" {...{
          "href": "https://twitter.com/codeability/status/1179136560110768128"
        }}>{`E.J. Mason`}</a></p>
    </blockquote>
    <h2>{`Installation and Quick Start`}</h2>
    <pre><code parentName="pre" {...{}}>{`yarn add honkify
`}</code></pre>
    <p>{`In your code:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import honkify from 'honkify';

// The goose is loose!
const unregister = honkify();

// Disable so links work again
unregister();
`}</code></pre>
    <h2>{`How to use this on a React site`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useState } from 'react';
import honkify from 'honkify';

const Honker = () => {
  const initialState = { active: false, unregister: () => {} };
  const [honk, setHonk] = useState(initialState);
  const toggleHonk = () => {
    if (!honk.active) {
      const unregister = honkify();
      setHonk({ active: true, unregister });
    }

    if (honk.active) {
      honk.unregister();
      setHonk(initialState);
    }
  };

  return (
    <button onClick={toggleHonk}>{honk.active ? 'unhonk' : 'honk!'}</button>
  );
};

export default Honker;
`}</code></pre>
    <h2>{`Disclaimer: please don’t use this`}</h2>
    <p>{`Or, if you do, make sure it’s easy to toggle off. Geese may be jerks, but developers shouldn’t be.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      